module.exports = __webpack_public_path__ + "static/media/img-function-rec@3x.b6b97673.png";